export const tiers = ['1000', '2000', '3000', 'prime'];
